import axios from "axios";

export const getTaxes = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/get-data`, data, { timeout: 15000 })
    .then((response) => response.data)
    .catch((e) => Promise.reject(e));
};

export const getUhs = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/get-data/get-uhs`, data, { timeout: 10000 })
    .then((response) => response.data)
    .catch((e) => Promise.reject(e));
};
